/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equal_Gross_Cobra_PatInputs */

const fr_equal_gross_cobra_pat = /** @type {(inputs: Equal_Gross_Cobra_PatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer le programme`)
};

/**

* @param {Equal_Gross_Cobra_PatInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const equal_gross_cobra_pat = /** @type {((inputs?: Equal_Gross_Cobra_PatInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equal_Gross_Cobra_PatInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_equal_gross_cobra_pat(inputs)
});